import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import PrimaryBoxInfo from 'components/Advanced_User/INSTAR_MQTT_Broker/OpenHAB2/PrimaryBox';
import PrimaryBox from 'components/Advanced_User/OpenHAB_Home_Automation/PrimaryBox';
import TimeLine from 'components/Products/CommentList/MqttIFTTTList';
import NavButtons from 'components/Advanced_User/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  PrimaryBoxInfo,
  PrimaryBox,
  TimeLine,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};